export const commonUrls = {
  countryJson: () => '/common/json/country.json',
  languageJson: () => '/common/json/language.json',
  workTypeJson: () => '/common/json/work_type.json',
  workModeJson: () => '/common/json/work_mode.json',
  imagePathBase: (environment?: string, imagePath?: string) =>
    `https://srustbucket.s3.ap-northeast-1.amazonaws.com/free-ist/upload/${
      environment === 'development' ? 'test' : 'prod'
    }/${imagePath ?? ''}`, // TODO: 新アプリのインフラが整ったら修正
}
